import { arrayOf, shape, string } from 'prop-types'
import { CustomField } from './custom-field'

export const Connector = shape({
  id: string.isRequired,
  name: string.isRequired,
  description: string.isRequired,
  custom_fields: arrayOf(CustomField)
})
